export default __webpack_public_path__ + "static/media/data-usage.41915a17.svg";